import { render, staticRenderFns } from "./AidexMgToC.vue?vue&type=template&id=36624e3e&scoped=true&"
import script from "./AidexMgToC.vue?vue&type=script&lang=js&"
export * from "./AidexMgToC.vue?vue&type=script&lang=js&"
import style0 from "./AidexMgToC.vue?vue&type=style&index=0&id=36624e3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36624e3e",
  null
  
)

export default component.exports